
import { MessageBox } from 'element-ui'

let util = {
    mesBoxPop: (text, state) => {
        MessageBox.confirm(text, "提示", {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: state,
        });
    },
    //阿拉伯数字转中文数字
    NoToChinese: function (num) {
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分) 
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },

   
    // 获取任意时期到任意时期的数组 精确到日 start 0表示今天,-1为昨天1为明天 end同理
    lastWeekDays: function (start, end) {
        const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        const currentTime = new Date().getTime()
        const dayTime = 24 * 60 * 60 * 1000;

        if (start >= end || start === undefined || end === undefined) {
            throw new Error('parmas start 不要大于或者等于 end');
        }

        const arr = []
        for (let i = 0; i <= (end - start); i++) {
            const date = new Date(currentTime - dayTime * i);
            arr.push({
                date: date,
                week: weeks[date.getDay()]
            });
        }


        return arr.reverse();
    }

}
export default util;